let load = require('./helpers/browser/esm-js-loader');
module.exports = Promise.all([load("axK8C"), load("fv5Zc"), load("akxri"), load("dh6UR"), load("e898Z"), load("3hQzT")]).then(() => parcelRequire('efKbd'));